import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Text, View } from '@coinscrap/webapp-core';

import TooltipSimple from 'components/TooltipSimple/TooltipSimple';

import openArrow from 'assets/images/svgStatic/keyboardArrowDown.svg';

import { downloadDoc } from 'helpers/downloadDoc';

import { PackagesValueCard } from './PackagesValueCard';
import * as S from './styles';

export const PackageCoverageCard = ({ index, coverage, packages, resumePdf }) => {
	const [isCoverageOpen, setIsCoverageOpen] = useState(false);

	const hideCoverage = packages?.every((pack) => {
		let value =
			pack?.capitalList?.item.length > 0
				? pack?.capitalList?.item.find((co) => co.description === coverage.description)
					?.value
				: pack?.coverageList?.capitalList.item.length > 0
					? pack?.coverageList?.capitalList.item.find(
						(co) => co.description === coverage.description,
					)?.value
					: '';
		if (value === '' || value === 'N') {
			return true;
		}
		return false;
	});

	if (hideCoverage) {
		return null;
	}
	return (
		<>
			{isMobile ? (
				<View gap4St>
					{index === 0 && (
						<>
							<View>
								<Text
									packagesDownloadPdfMobileSt
									onClick={() => downloadDoc(resumePdf, 'Presupuesto')}
								>
									Guardar presupuesto
								</Text>
							</View>
							<View rowSt justifyStartSt>
								<Text headingSecondarySt>Compara las coberturas</Text>
							</View>
						</>
					)}
					<View coverageCellMobileSt>
						<View rowSt justifyBetweenSt alignItemsCenterSt gap2St>
							<Text coverageMobileCellSt>{coverage.description}</Text>
							<S.OpenArrow
								isOpen={isCoverageOpen}
								onClick={() => setIsCoverageOpen(!isCoverageOpen)}
							>
								<img src={openArrow} alt={'arrow icon'} style={{ width: '100%' }} />
							</S.OpenArrow>
						</View>
						{coverage.tooltip !== '' && (
							<View rowSt justifyStartSt alignItemsCenterSt gap2St>
								<Text>Más información</Text>
								<TooltipSimple>
									<Text>{coverage.tooltip}</Text>
								</TooltipSimple>
							</View>
						)}
						{isCoverageOpen && (
							<View coverageMobileContentSt>
								{packages.length > 0 &&
									packages.map((pack, index) => (
										<PackagesValueCard
											key={index}
											index={index}
											coverage={coverage}
											pack={pack}
											isMobile={isMobile}
										/>
									))}
							</View>
						)}
					</View>
				</View>
			) : (
				<View displayGridSt gridCols5St gap4St>
					<View colSpan2St>
						<S.CoverageCell coverageCellSt rowSt justifyBetweenSt alignItemsCenterSt>
							<Text coverageCellSt>{coverage.description}</Text>
							{coverage.tooltip !== '' && (
								<View widthFitContentSt>
									<TooltipSimple>
										<Text>{coverage.tooltip}</Text>
									</TooltipSimple>
								</View>
							)}
						</S.CoverageCell>
					</View>
					{packages.length > 0 &&
						packages.map((pack, index) => (
							<PackagesValueCard
								key={index}
								coverage={coverage}
								pack={pack}
								isMobile={isMobile}
							/>
						))}
				</View>
			)}
		</>
	);
};
